import { Action, combineReducers } from '@ngrx/store';

import {
  GET_HOLD_AMOUNTS,
  SET_HOLD_LIST_VIEW
} from '../actions';

const initialHoldListViewState = {
  loading: <boolean>false
};

export function holdAmountsReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_HOLD_AMOUNTS:
      return [ ...action.payload.holdAmounts ];
    default:
      return state;
  }
}
export function holdListViewReducer(state = initialHoldListViewState, action: Action) {
  switch (action.type) {
    case SET_HOLD_LIST_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export const holdReducers = combineReducers({
  holdAmounts: holdAmountsReducer,
  holdListView: holdListViewReducer
});



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/holds.ts